import React from 'react';

import datajson from './data/data.json';
import filterjson from './data/filter.json';
import configjson from './data/config.json';

import SearchCard from './component/SearchCard';
import { TwoArrayHasCommonElement } from './Utils';
import CardDialog from './component/SearchCardDialog';
import ToTop from './component/ToTop';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';

function SearchPage() {

    const [openDialog, setOpenDialog] = React.useState(false);
    const [displayCard, setDisplayCard] = React.useState();
    const [pageCard, setPageCard] = React.useState();
    const [criteria, setCriteria] = React.useState(filterjson.filter(x => x.enable).map(y => { let v = y.option.filter(z => z.visible).map(a => { return a.key; }); return { "key": y.key, "value": v }; }));
    const [openCard, setOpenCard] = React.useState(false);
    const [cardContent, setCardContent] = React.useState();


    const sortDataJson = (data) => {
        return data.filter(x => x.enable).sort((a, b) => a.group.localeCompare(b.group));
    };

    React.useEffect(() => {
        // setDisplayCard(getDisplayCard(datajson));
        let dcard = sortDataJson(datajson).map((x, i) => (<SearchCard key={i} data={x} onClick={cardOnClick} />));
        setDisplayCard(dcard);
        setPageCard(dcard.slice(0, 12));
    }, []);

    const filterIconOnClick = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const getDialogCriteria = () => {
        let group = Object.entries(document.getElementsByClassName("filteroptions"));
        let ary = {};
        group.forEach(x => {
            let name = x[1].getAttribute("data-key");
            ary[name] = [];
        });

        let elm = Object.entries(document.getElementsByClassName("filterchipon"));
        // let ary = {};
        elm.forEach(x => {
            let key = x[1].getAttribute("data-key");
            let pkey = x[1].getAttribute("data-parentkey");
            // if (!ary[pkey]) {
            //     ary[pkey] = [];
            // }
            ary[pkey].push(key);
        });
        // console.log("ary", ary);

        let tmp = Object.keys(ary).map(x => { return { "key": x, "value": ary[x] } });
        // console.log("criteria", tmp);

        return tmp;
    };

    const searchOnClick = () => {
        setOpenDialog(false);
        let criteria = getDialogCriteria();
        setCriteria(criteria);

        let matched = datajson;

        criteria.forEach(x => {
            let tmp = datajson.filter(a => a.enable).map(y => {
                let cary = x.value;
                let dary = y[x.key];

                if (TwoArrayHasCommonElement(cary, dary.split(", "))) {
                    return y;
                }
                return undefined;
            });
            // console.log("c-tmp", tmp);

            // get intersection
            let interset = tmp.filter(t => (typeof (t) != "undefined")).filter(t => {
                let arr = matched.filter(m => m.id === t.id)
                return !(arr.length === 0)
            });

            matched = interset;
        });

        // console.log("matched", matched);

        // let html = matched.filter(x => x.enable).map((x) => {
        //     return <div key={x.id}>{x.group}</div>
        // });
        // setDisplayCard(<SearchCardList data={matched.filter(x => x.enable)} />);
        let dcard = sortDataJson(matched).map((x, i) => (<SearchCard key={i} data={x} onClick={cardOnClick} />));
        setDisplayCard(dcard);
        setPageCard(dcard.slice(0, 12));
    };


    const filterChipOnClick = (elm) => {
        let chipelm = elm.target;

        if (!chipelm.classList.contains("filterchip"))
            chipelm = chipelm.parentElement;

        if (chipelm.classList.contains("filterchipon"))
            chipelm.classList.remove("filterchipon");
        else
            chipelm.classList.add("filterchipon");
    };


    const closeCardDialog = () => {
        setOpenCard(false);
    };

    const cardOnClick = (elm) => {
        setOpenCard(true);

        // console.log(elm, elm.target, elm.currentTarget);

        let itemid = elm.currentTarget.getAttribute("data-id");
        let detail = datajson.filter(x => x.id.toString() === itemid);
        // console.log("card on click", itemid, detail);
        setCardContent(detail[0]);
    };

    const pagingOnChange = (ev, pagenum) => {
        let dcard = displayCard;
        let from = (pagenum - 1) * 12;
        let to = pagenum * 12;
        let pcard = dcard.slice(from, to);
        setPageCard(pcard);
    };


    return (
        <>
            <div className='pageinfo'>
                <div>
                    <div className=''>**按店名順序排列</div>
                    <div className='itemcount'>總數 : {displayCard ? displayCard.length : "/"} </div>
                    <div className='lastupdated'>最後更新 : {configjson.lastupdate} </div>
                </div>
                <div className='filtericon'><FilterAltIcon onClick={filterIconOnClick} /></div>
            </div>

            {/* <Button onClick={cardOnClick}>card dialog</Button> */}

            <div className='resultwrapper'>
                {pageCard}
            </div>
            {
                displayCard &&
                <Stack spacing={2}>
                    <Pagination count={Math.ceil(displayCard.length / 12)} defaultPage={1} onChange={pagingOnChange}  />
                </Stack>
            }

            {/* <DialogTest open={openDialog}  handleClose={handleClose} /> */}
            <Dialog open={openDialog} onClose={handleClose}>
                <DialogContent>
                    {
                        filterjson.filter(x => x.enable).map(item =>
                        (
                            <div key={item.key} className='filtergroup'>
                                <div className='filterheader'>{item.displayname}</div>
                                <div className='filteroptions' data-key={item.key}>
                                    <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" flexWrap="wrap" >
                                        {
                                            item.option.filter(y => y.visible).map((y) => {
                                                let tmpc = criteria.filter(a => a.key === item.key);
                                                let selected = tmpc[0] && tmpc[0].value.indexOf(y.key) > -1 ? true : false;
                                                return (<Chip variant="outlined" key={y.key} data-key={y.key} data-parentkey={item.key} label={y.value} className={"filterchip " + (selected ? "filterchipon" : "")} onClick={filterChipOnClick} />)
                                            })
                                        }
                                    </Stack>
                                </div>
                            </div>
                        ))
                    }
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Cancel</Button> */}
                    <Button onClick={searchOnClick}>Search</Button>
                </DialogActions>
            </Dialog>

            {/* card dialog */}
            <CardDialog isOpen={openCard} onClose={closeCardDialog} item={cardContent} />

            <ToTop />
        </>
    );

}


// function DialogTest({openDialog, handleClose }) {
//     return (
//         <Dialog open={openDialog} onClose={handleClose}>
//             <DialogContent>
//                 {
//                     datajson.map(x => x.group)
//                 }
//             </DialogContent>
//             <DialogActions>
//                 {/* <Button onClick={handleClose}>Cancel</Button> */}
//                 {/* <Button onClick={searchOnClick}>Search</Button> */}
//             </DialogActions>
//         </Dialog>
//     )
// }

export default SearchPage;
